import React from 'react'
import GitHubCalendar from 'react-github-calendar';

export default function GithubCalender() {
    return (
        <div>
            <GitHubCalendar username="saikhmirsat" />
        </div>
    )
}
